import { Box, Breadcrumbs, FormControl, IconButton, InputLabel, Link, MenuItem, Pagination, Select, Stack, TablePagination, Typography } from "@mui/material"
import RefreshButton from "../../components/global/RefreshButton"
import PrimaryButton from "../../components/global/PrimaryButton"
import DynamicIcon from "../../components/global/DynamicIcon"
import CascateList from "../../components/global/CascateList"
import Input from "../../components/global/Input"
import 'dayjs/locale/pt-br'
import { DataGrid, GridColDef } from '@mui/x-data-grid-pro'
import { useContext, useEffect, useState } from "react"
import { FiltersCargo, useCargoStore } from "../../stores/rh/cargo"
import ItemStatus from "../../components/global/ItemStatus"
import { useNavigate } from "react-router"
import DeleteDialog from "../../components/global/DeleteDialog"
import { Cargo } from "../../types/rh/cargo"
import { rhAPI } from "../../api"
import AlertErro from "../../components/global/AlertErro"
import { AppContext } from "../../common/contexts/app_context/app_context"
import StyledDataGrid from "../../components/global/StyledDataGrid"

function CargoList() {
  const { setNoticeOpen, setMessageNotice } = useContext(AppContext)
  const { filters, setFilters, cleanFilters, setCargos, loadingCargos, cargos, totalItems, setSelectedCargoId, setLoadingCargos, selectedCargoId, erroCargos, messageErroCargos, isFiltered } = useCargoStore()
  const [dialogDeleteOpen, setDialogDeleteOpen] = useState(false)
  const [selectedCargo, setSelectedCargo] = useState<Cargo>()
  const [erroSave, setErroSave] = useState(false)
  const [messageErroSave, setMessageErroSave] = useState("")
  const navigate = useNavigate()
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    if (cargos.length == 0 && isFiltered() == false) {
      cleanFilters()
      setIsInitialized(true)
    }
  }, [cargos])

  const handlePaginationChange = async (event: React.ChangeEvent<unknown> | null, page: number) => {
    const updatedFilters: FiltersCargo = {
      ...filters,
      page: page + 1,
    }
    setFilters(updatedFilters)
    await setCargos(updatedFilters)
  }

  const handleChangeRowsPerPage = async (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const updatedFilters: FiltersCargo = {
      ...filters,
      page: 1,
      pageSize: parseInt(event.target.value, 10)
    }
    setFilters(updatedFilters)
    await setCargos(updatedFilters)
  };

  const handleDelete = async () => {
    setErroSave(false)
    setDialogDeleteOpen(false)
    if (selectedCargoId != 0) {
      setLoadingCargos(true)
      var result = await rhAPI.deleteCargo(selectedCargoId)
      if (result.statusCode != 200) {
        setErroSave(true)
        setMessageErroSave(result.error?.Message ?? "Ocorreu um erro inesperado.")
        setMessageNotice("Ocorreu algum erro ao tentar deletar.")
        setNoticeOpen(true)
      }
      else {
        setMessageNotice("Cargo excluído com sucesso!")
        setNoticeOpen(true)
      }
      await setCargos(filters)
    }
  }

  const handleReload = async () => {
    setErroSave(false)
    await setCargos(filters)
    setMessageNotice("Página recarregada com sucesso!")
    setNoticeOpen(true)
  }

  const columns: GridColDef[] = [
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      minWidth: 100,
      flex: 1,
      sortable: false,
      headerClassName: 'cargos-header',
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus title={params.value == true ? "A" : "I"} color={params.value == true ? "green" : "red"} description={params.value == true ? "Cargo Ativo" : "Cargo Inativo"} />
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 2,
      minWidth: 150,
      sortable: false,
      headerClassName: 'cargos-header',
    },
    {
      field: "atribuicoes",
      filterable: false,
      headerName: "Atribuições",
      flex: 2,
      minWidth: 150,
      sortable: false,
      headerClassName: 'cargos-header',
    },
    {
      field: "escolaridade",
      filterable: false,
      headerName: "Escolaridade",
      minWidth: 150,
      flex: 2,
      sortable: false,
      headerClassName: 'cargos-header',
    },
    {
      field: 'idCargo',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => {
              setSelectedCargoId(params.value)
              navigate("/Cargos_cadastro")
            }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>
            <IconButton
              onClick={() => {
                setSelectedCargo(params.row)
                setSelectedCargoId(params.value)
                setDialogDeleteOpen(true)
              }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        )
      },
    }
  ]

  return (
    <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
      <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
        <Link underline="hover" color="inherit" >
          RH
        </Link>
        <Typography className="text-primary-green">Cargos</Typography>
      </Breadcrumbs>
      <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Cargos</h1>
          <RefreshButton onClick={async () => await handleReload()} />
        </div>
        <div className="w-full justify-end flex">
          <div className="w-[180px] ">
            <PrimaryButton startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
              onClick={() => {
                setSelectedCargoId(0)
                navigate("/Cargos_cadastro")
              }}>
              Novo cargo
            </PrimaryButton>
          </div>
        </div>
      </div>
      {
        erroCargos == true &&
        <div className="w-full">
          <AlertErro messageErro={messageErroCargos} onTryAgain={async () => await handleReload()} />
        </div>
      }
      {
        erroCargos == false &&
        <>
          <CascateList
            title="Filtros"
            defaultOpen>
            <div className="w-full flex flex-col gap-6 items-center justify-center">
              <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 grid-flow-row-dense ">

                <Input
                  variant="outlined"
                  label="Pesquisar por nome"
                  value={filters.pesquisarNome}
                  onChange={(x) => {
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      pesquisarNome: x.target.value,
                    }))
                  }}
                  onChangeDebounce={async (value) => {
                    const updatedFilters: FiltersCargo = {
                      ...filters,
                      pesquisarNome: value ?? "",
                    }
                    if (isInitialized == true) {
                      await setCargos(updatedFilters)
                    }
                  }} />
                <Input
                  variant="outlined"
                  label="Pesquisar por atribuições"
                  value={filters.pesquisarAtribuicoes}
                  onChange={(x) => {
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      pesquisarAtribuicoes: x.target.value,
                    }))
                  }}
                  onChangeDebounce={async (value) => {
                    const updatedFilters: FiltersCargo = {
                      ...filters,
                      pesquisarAtribuicoes: value ?? "",
                    }
                    if (isInitialized == true) {
                      await setCargos(updatedFilters)
                    }
                  }}
                />
                <Input
                  variant="outlined"
                  label="Pesquisar por escolaridade"
                  value={filters.pesquisarEscolaridade}
                  onChange={(x) => {
                    setFilters((prevFilters) => ({
                      ...prevFilters,
                      pesquisarEscolaridade: x.target.value,
                    }))
                  }}
                  onChangeDebounce={async (value) => {
                    const updatedFilters: FiltersCargo = {
                      ...filters,
                      pesquisarEscolaridade: value ?? "",
                    }
                    if (isInitialized == true) {
                      await setCargos(updatedFilters)
                    }
                  }}
                />
                <FormControl size="small" fullWidth>
                  <InputLabel id="modulo-dashboard">Status</InputLabel>
                  <Select
                    labelId="modulo-dashboard"
                    label="Status"
                    value={filters.status}
                    onChange={async (x) => {
                      const updatedFilters: FiltersCargo = {
                        ...filters,
                        status: x.target.value as number,
                      }
                      setFilters(updatedFilters)
                      if (isInitialized == true) {
                        await setCargos(updatedFilters)
                      }
                    }}
                  >
                    <MenuItem value={0}>Todos</MenuItem>
                    <MenuItem value={1}>Ativos</MenuItem>
                    <MenuItem value={2}>Inativos</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="w-full flex justify-end">
                <div className="w-[180px]">
                  <PrimaryButton
                    startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                    buttonColor="yellow"
                    onClick={() => cleanFilters()}>Limpar filtros</PrimaryButton>
                </div>
              </div>
            </div>
          </CascateList>
          {
            erroSave == true &&
            <div className="w-full">
              <AlertErro messageErro={messageErroSave} onTryAgain={async () => setDialogDeleteOpen(true)} onClose={() => setErroSave(false)} />
            </div>
          }
          <Stack spacing={0}>
            <TablePagination
              component="div"
              count={totalItems}
              page={filters.page - 1}
              onPageChange={handlePaginationChange}
              rowsPerPage={filters.pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <StyledDataGrid
              getRowId={(row) => row.idCargo}
              columns={columns}
              loading={loadingCargos}
              rows={cargos}
              rowCount={totalItems}
              paginationMode="server"
              paginationModel={{
                page: filters.page - 1,
                pageSize: filters.pageSize,
              }}
            />
            <TablePagination
              component="div"
              count={totalItems}
              page={filters.page - 1}
              onPageChange={handlePaginationChange}
              rowsPerPage={filters.pageSize}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Stack>
        </>
      }
      <DeleteDialog
        open={dialogDeleteOpen}
        onClose={() => setDialogDeleteOpen(false)}
        title={`Você realmente deseja excluir o cargo ${selectedCargo?.descricao}?`}
        onDelete={handleDelete}
      />
    </div>
  )
}

export default CargoList;